﻿import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DataService } from "../services/dataService";
import { HttpInterceptorService } from '../services/http-interceptor.service';

import { CasesModule, casesRoutes } from "../cases/cases.module";

import { DashboardComponent } from "./dashboard.component";
import { CaseDetailMainComponent } from "../cases/caseDetailMain.component";
import {AuthenticationGuard, StaffAuthGuard,AllAuthGuard} from "../guards/auth.guard";


let myWorkRoutes = <any[]>casesRoutes;
myWorkRoutes.push({ path: "casedetail", component: CaseDetailMainComponent, canActivate: [AuthenticationGuard, AllAuthGuard]});
myWorkRoutes.push({ path: "", redirectTo: "mywork", pathMatch: "full", canActivate: [AuthenticationGuard, AllAuthGuard] });
//myWorkRoutes.push({ path: "", redirectTo: "searchcase", pathMatch: "full", canActivate: [AuthenticationGuard, AllAuthGuard] });
myWorkRoutes.push({ path: "mywork", redirectTo: "searchcase", pathMatch: "full", canActivate: [AuthenticationGuard, AllAuthGuard] });


let myWorkRoute = [{ path: "dashboard", component: DashboardComponent, children: myWorkRoutes }];

@NgModule({
    imports: [HttpClientModule,CommonModule,  CasesModule,  RouterModule.forChild(myWorkRoute)],
    declarations: [DashboardComponent],
    exports: [DashboardComponent],
    providers: [DataService,HttpInterceptorService, StaffAuthGuard, AllAuthGuard,{ provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true }]
})
export class DashboardModule { }
